import dayjs from 'dayjs';

import { TDate, TDateRange } from '@/shared/types/app.types';

const toValidDate = (value: TDate | null | undefined, hour: number, minute: number): Date => {
	const date = dayjs(value ?? null);
	return date.isValid()
		? date.toDate()
		: dayjs().hour(hour).minute(minute).second(0).millisecond(0).toDate();
};

// Незаданное или некорректное рабочее время заменяется дефолтом 9:00–17:30
export const normalizeWorkTime = (
	workTime?: [TDate | null, TDate | null] | TDateRange | null,
): [Date, Date] => [toValidDate(workTime?.[0], 9, 0), toValidDate(workTime?.[1], 17, 30)];
